<script>
import { mapGetters } from 'vuex'

export default {
    name: 'App',
    computed: {
        ...mapGetters(['serverConfig', 'userId', 'locationNearest'])
    },
    data() {
        return {
            loading: true
        }
    },
    async beforeMount() {
        try {
            await this.$store.dispatch('appInitialize')
        } catch (e) {
            if (e.response?.status == 401) {
                this.$router.push({ name: 'login', query: { code: 'sessionInvalid' } })
            }
        } finally {
            const branding = this.locationNearest?.attributes.branding || {}
            this.$branding.setTheme({
                theme: branding.design_theme,
                primary: branding.design_color_primary,
                secondary: branding.design_color_secondary,
                navBg: branding.design_color_nav_bg,
                navLinks: branding.design_color_nav_links,
                navLinksHover: branding.design_color_nav_links_hover,
                fontURL: branding.design_font_url,
                fontFamily: branding.design_font_family,
                extraCSS: branding.design_extra_css,
            })

            this.loading = false
        }
    },
}
</script>

<template>
    <div class="app-main">
        <div class="app-loaded" v-if="!loading">
            <router-view name="nav" />
            <router-view name="body" class="app-body" />
            <router-view name="footer" />
        </div>

        <div class="app-loading" v-else>
            <div class="spinner-grow">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
html {
    height: 100%;
}

body {
    height: 100%;
    background-color: var(--sos-bg);

    &.background-fixed {
        background-attachment: fixed;
    }

    &.r8 {
        background-image: url('~@/assets/overlay.png'), url('~@/assets/hero-top.jpg');
        background-size: auto, cover;
    }

    &.porsche {
        background-image: url('~@/assets/overlay.png'), url('~@/assets/porsche.jpg');
        background-size: auto, cover;
    }

    &.porsche-nur {
        background-image: url('~@/assets/overlay.png'), url('~@/assets/porsche-nurburgring.jpg');
        background-size: auto, cover;
    }

    &.verstappen {
        background-image: url('~@/assets/overlay.png'), url('~@/assets/max-verstappen-simulator.jpg');
        background-size: auto, cover;
    }

    &.amg-gts {
        background-image: url('~@/assets/overlay.png'), url('~@/assets/8575487088738172940_0.jpg');
        background-size: auto, cover;
    }

    &.f1-rear {
        background-image: url('~@/assets/f1-rear.jpg');
        background-repeat: no-repeat;
        background-size: 100%;
        background-position-y: 0%;
        background-color: #060606;
    }
    
    &.f1-rear-opaque {
        background-image: url('~@/assets/f1-rear-opaque.jpg');
        background-repeat: no-repeat;
        background-size: 100%;
        background-position-y: 0%;
        background-color: #010101;
    }

    &.mclarens {
        background-image: url('~@/assets/welcome-slide-3.jpg');
        background-repeat: no-repeat;
        background-size: 100%;
        background-position-y: 0%;
        background-color: #060606;
    }
}

.app-loading {
    text-align: center;

    .spinner-grow {
        width: 3rem;
        height: 3rem;
        position: absolute;
        top: 40%;
        color: var(--sos-accent);
    }
}

@media (min-width: 768px) { 
    .app-body {
        height: 100%;
        min-height: 700px;
    }
}
</style>
